import { __makeTemplateObject } from "tslib";
import React from 'react';
import { Box } from '@material-ui/core';
import styled from 'styled-components';
import { Text } from '../Text/Text';
import { useMessageBar } from './MessageBarContext';
import { messageBarPalette } from './palette';
export var MessageBarText = function (_a) {
    var children = _a.children, _b = _a.component, component = _b === void 0 ? 'p' : _b;
    var variant = useMessageBar();
    return (React.createElement(Box, { mb: 1 },
        React.createElement(SText, { component: component, "$variant": variant }, children)));
};
var SText = styled(Text)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var $variant = _a.$variant;
    return messageBarPalette[$variant].color;
});
var templateObject_1;
//# sourceMappingURL=MessageBarText.js.map